exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd.date-cell div.cell {\n  position: absolute;\n  top: 3px;\n  width: 100%;\n  height: 89%;\n  padding: 0 2px;\n}\nth.date-cell-label div.cell {\n  white-space: pre;\n  text-align: center;\n}\n.selected-button {\n  font-size: 20px;\n}\n/* .selected-button span::before {\n        content: \"v \"\n    } */\n#inTableShiftAssignmentForm .box-body .el-button:first-child {\n  margin-left: 9px;\n}\n", ""]);

// exports
